<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" v-if="isHavePermission('logistics2.0:updateLogisticTrack')" @click="reTrack">更新轨迹
      </Button>
      <!-- <vxe-button icon="vxe-icon--refresh" @click="refresh"
                  :style="isHavePermission('logistics2.0:updateLogisticTrack')? 'margin-left: 10px' :''">
        刷新
      </vxe-button> -->
      <Button icon="md-refresh" @click="refresh"
              :style="isHavePermission('logistics2.0:updateLogisticTrack')? 'margin-left: 10px' :''"
      >刷新
      </Button>
      <Button icon="md-download" @click="download" style="margin-left: 10px"
              v-if="isHavePermission('logistics2.0:download')"
      >导出
      </Button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form
                :data="searchFormData"
                title-align="left"
            >
              <vxe-form-item title="搜索" field="receiveNum" span="24"
                             :prefix="{icon: 'fa fa-address-card-o'}"></vxe-form-item>
              <vxe-form-item title="订单编号" field="ordersNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.ordersNum" placeholder="输入订单编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="物流编号" field="logisticsNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.logisticsNum" placeholder="输入物流编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="物流单号" field="logisticsCode" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.logisticsCode" placeholder="输入物流单号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="状态" field="logisticsState" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.logisticsState" :options="logisticsIsTopOptions" clearable
                              placeholder="全部"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="附件筛查" field="logisticsFileState" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.logisticsFileState" :options="fileOptions" placeholder="全部"
                              clearable></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务类型" field="logisticsType" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.logisticsType" :options="logisticsTypeOption" clearable
                              placeholder="全部"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.goodsName" placeholder="输入货名"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.carShipNum" placeholder="输入车船号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运地" field="beginPlace" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.beginPlace" placeholder="输入起运地"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="目的地" field="endPlace" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.endPlace" placeholder="输入目的地"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运时间" field="beginTime" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.beginTime" :options="timeOptions" placeholder="选择时间"
                              clearable></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="到达时间" field="endTime" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.endTime" :options="timeOptions" placeholder="选择时间"
                              clearable></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船认证" field="carShipState" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.carShipState" :options="fileOptions" clearable
                              placeholder="全部"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车辆是否有轨迹" field="hasTrackUrl" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.hasTrackUrl" :options="fileOptions" clearable
                              placeholder="全部"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人" field="buyerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchBuyerName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'buyerNameOptions','twoOrders','searchCondition',3)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'buyerNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in buyerNameOptions" :value="option.name"
                            :key="option.name">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人" field="sellerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :remote-method="(file) =>remoteMethod(file,'sellerNameOptions','twoOrders','searchCondition',4)"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'sellerNameOptions')"
                      placeholder="输入承运人"
                  >
                    <Option v-for="option in sellerNameOptions" :value="option.name"
                            :key="option.name">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="所属公司" field="compName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCompName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'compNameOptions','twoOrders','searchCondition',1)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'compNameOptions')"
                      placeholder="输入所属公司"
                  >
                    <Option v-for="option in compNameOptions" :value="option.id"
                            :key="option.name">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUserName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) =>remoteMethod(file,'createUserNameOptions','twoOrders','searchCondition',7)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'createUserNameOptions')"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserNameOptions" :value="option.id"
                            :key="option.name">{{ option.name }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.createTime" :options="timeOptions" clearable
                              placeholder="选择时间"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button type="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px;">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置</Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal class="timeModal" v-model="open" width="460" height="400" :show-footer="false" :showHeader="false">
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          ref="xGrid"
          align="center"
          border="none"
          max-height="600"
          :data="tableData"
          :loading="loading"
          @sort-change="sortChangeEvent"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          resizable
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown trigger="click" style="margin-left: 10px; color: #666;cursor: pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" v-if="isHavePermission('agreement2.0:update')"
                          @click="openEditView(row.id)">编辑
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNum" title="物流编号" width="130">
          <template slot-scope="{ row }">
            <span @click="showLogisticsDetail(row.id)"
                  style="color: #2D8CF0;cursor:pointer">{{ row.logisticsNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsCode" title="物流单号" width="130"></vxe-table-column>
        <vxe-table-column field="logisticsState" title="状态" width="120" show-overflow>
          <template slot-scope="{ row }">
            <span :style="isHavePermission('logistics2.0:logisticsState')? 'margin-left: 25px;':''">{{
                row.logisticsState | logisticsIsTopStatusMap
              }}</span>
            <Dropdown
                v-if="isHavePermission('logistics2.0:logisticsState')"
                trigger="click" style="margin-left: 10px;;cursor:pointer" transfer>
              <span style="position:relative; margin-left:20px; ">
                <Icon type="ios-arrow-down" style="margin-top:-3px;"/>
              </span>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <!-- 物流状态 :  1->正常对应目前已审核 有轨迹且匹配（）、0->未知（对应目前待审核）、-1->数据异常（轨迹不匹配）、-2->离线（无轨迹） -->
                  <!-- -3 ->通信异常（平台无轨迹其他家有）、-4->AIS异常（有定位无轨迹）此状态只有船舶有 -->
                  <section v-for="item in logisticsIsTopOptions" v-bind:key="item.value">
                    <Button class="button-gengduo" v-if="row.logisticsState != item.value "
                            @click="setTop(row.id, item.value)">{{ item.label }}
                    </Button>
                  </section>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsType" title="业务类型" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.logisticsType | logisticsTypeMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105" show-overflow></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="60" show-overflow></vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="140" show-overflow>
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content:center;">
              <span v-if="row.logisticsType === 1 && isHavePermission('logistics2.0:carShipDetail')"
                    :style="row.carShipState === 3 ? 'color: #2D8CF0;cursor:pointer': 'cursor:pointer'"
                    @click="showCarDetail(row)">{{ row.carShipNum }}</span>
              <span v-else-if="row.logisticsType === 2 && isHavePermission('logistics2.0:carShipDetail')"
                    :style="row.carShipState === 3 ? 'color: #2D8CF0;cursor:pointer': 'cursor:pointer'"
                    @click="showShipDetail(row)">{{ row.carShipNum }}</span>
              <span v-else>{{ row.carShipNum }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isHavePermission('logistics2.0:getMap')" title="轨迹" width="50" show-overflow>
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content:center;">
              <img v-if="row.trackUrl || row.logisticsType === 2"
                   style="width: 20px;height: 20px;" src="@/assets/images/common/icon-guiji.png"
                   @click="getMap(row)"/>
              <img v-else style="width: 20px;height: 20px;" src="@/assets/images/common/icon-noguiji.png"/>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="endPlace" title="目的地" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="140" remote-sort>
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="140" remote-sort>
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="平台企业" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号" width="140">
          <template slot-scope="{ row }">
            <span @click="openOrderDetail(row.id)"
                  style="color: #2D8CF0;cursor:pointer">{{ row.ordersNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100" show-overflow></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120" remote-sort
                          v-if="isHavePermission('logistics2.0:createTime')">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="detailVisible" :title="detailTitle" width="1300" height="940" @close="closeDetail"
               resize position="center">
      <detail ref="detailModal" @afterSave="afterSave" @update="goUpdate"></detail>
    </vxe-modal>
    <vxe-modal v-model="createCarVisible" :title="createCarTitle" width="1400" height="860" @close="closeCarCreate"
               resize position="center">
      <create-car-modal @afterSave="closeCarCreateModal" ref="modalCarCreate"
                        @close="closeCar"></create-car-modal>
    </vxe-modal>
    <vxe-modal v-model="createShipVisible" :title="createShipTitle" width="1400" height="900" @close="closeShipCreate"
               resize position="center" destroy-on-close>
      <create-ship-modal @afterSave="closeShipCreateModal" @close="createShipVisible = false"
                         ref="modalShipCreate"></create-ship-modal>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" position="center">
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
    <div class="search-filter">
      <vxe-modal class="timeModal" v-model="open" width="460" height="400" :show-footer="false" :showHeader="false">
        <template v-slot>
          <DatePicker
              :open="open"
              confirm
              type="daterange"
              :split-panels="true"
              placeholder
              style="width: 432px"
              @on-change="handleChange"
              @on-clear="handleClear"
              @on-ok="handleOk"
          >
            <span class="date-slot"></span>
          </DatePicker>
        </template>
      </vxe-modal>
    </div>
  </div>
</template>

<script>
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";
import Message from "@/components/common/Message";
import Detail from "@/components/order2.0/Logistics/DetailModal";
import $api from '@/apiProvider';
import $C from "@/consts/index";
import moment from "moment";
import {SEARCH_TIME} from "@/filters/time";
import getAuthOrization from "@/mixin/getAuthOrization";
import {getBlob, hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";
import viewOrderDetail from "@/mixin/viewOrderDetail";

export default {
  name: 'LogisticsList',
  components: {Detail, CreateCarModal, CreateShipModal, Message},
  mixins: [viewOrderDetail, getAuthOrization],
  data() {
    return {
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: '',
      createShipTitle: '',
      loading: false,
      searchLoading: false,
      searchVisible: false,
      open: false,
      trackFlag: false,
      url: '',
      tableData: [],
      logisticsTypeOption: $C.logisticsType.options,
      fileOptions: $C.HAS_FILE_TYPE.options,
      logisticsIsTopOptions: $C.LogisticsIsTopStatus.options,
      timeOptions: SEARCH_TIME.options,
      searchBuyerName: [],
      searchSellerName: [],
      searchCompName: [],
      searchCreateUserName: [],
      searchClientName: [],
      buyerNameOptions: [],
      sellerNameOptions: [],
      compNameOptions: [],
      createUserNameOptions: [],
      clientNameOptions: [],
      searchFormData: {
        ordersNum: null,
        logisticsNum: null,
        logisticsCode: null,
        logisticsState: null,
        hasFile: null,
        busType: null,
        goodsName: null,
        carShipNum: null,
        hasTrackUrl: null,
        beginPlace: null,
        endPlace: null,
        beginTime: null,
        endTime: null,
        createTime: null,
        logisticsFileState: null,
        carShipState: null
      },
      shipObj: {},
      paramsObj: {
        orderBy: 6,
        isDesc: 1,
        page: 1,
        rows: 10,
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      title: '',
      visible: false,
      detailVisible: false,
      detailTitle: '',
      updateVisible: false,
      templateVisible: false,
      records: [],
      messageVisible: false
    }
  },
  watch: {
    "searchFormData.beginTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("beginTime");
      },
    },
    "searchFormData.endTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("endTime");
      },
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
    $route: {
      deep: true,
      immediate: true,
      handler: function (to, from) {
        let type = parseInt(this.$route.params.type);
        if (to.name === "物流2.0") {
          if (type) {
            this.reset();
            let beginDate = this.$utils.toDateString(this.$route.params.beginDate, 'yyyy-MM-dd');
            let endDate = this.$utils.toDateString(this.$route.params.endDate, 'yyyy-MM-dd');
            this.searchFormData.createTime = [beginDate, endDate];
            if (type === 1) {
              this.searchFormData.logisticsFileState = 0;
              this.searchFormData.logisticsState = null;
              this.searchFormData.carShipState = null;
            } else if (type === 2) {
              this.searchFormData.logisticsFileState = null;
              this.searchFormData.logisticsState = 0;
              this.searchFormData.carShipState = null;
            } else {
              this.searchFormData.logisticsFileState = null;
              this.searchFormData.logisticsState = null;
              this.searchFormData.carShipState = 0;
            }

            if (parseInt(this.$route.params.userType) === 0) {
              this.getList('','createUserNameOptions','twoOrders','searchCondition',7);
              this.searchCreateUserName = [];
              this.searchCreateUserName.push(parseInt(this.$route.params.clientManager));
            } else {
              this.salesManId = parseInt(this.$route.params.clientManager);
            }

            this.getSearchListKey();
          }
          // else {
          //   this.paramsObj = {
          //     orderBy: 6,
          //     isDesc: 1,
          //     page: 1,
          //     rows: 10,
          //   };
          //   this.queryLogisticsListByObj(this.paramsObj);
          // }
        }
      }
    },
  },
  mounted() {
    this.$bus.$on("物流2.0", () => {
      this.reset();
      this.getSearchListKey();
    });
    // this.querysalesManage();
    this.queryLogisticsListByObj(this.paramsObj);
  },
  methods: {
    async querysalesManage() {
      let self = this;
      this.clientNameOptions = [];
      let data = {
        type: 2,
      };
      let res = await $api.baseUserSales.request(
          "querySalesSelectQuick",
          data
      );
      if (res.status === 1) {
        let data = res.data;
        data.map(i => {
          let obj = {};
          obj.id = i.id;
          obj.name = i.text;
          self.clientNameOptions.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openEditView(id) {
      this.detailTitle = '编辑物流';
      this.detailVisible = true;
      this.$refs.detailModal.showUpdate(id);
    },
    goUpdate() {
      this.detailTitle = '编辑物流'
    },
    openOrderDetail(id) {
      if (!this.isHavePermission('ordersTwo:detail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`
      };
      window.open(obj.path);
      // this.$store.dispatch("tagsView/addVisitedView", obj);
      // this.$router.push(obj.path);
      return false;
    },
    showLogisticsDetail(id) {
      if (!this.isHavePermission('logistics2.0:showDetail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.detailTitle = '物流详情';
      this.detailVisible = true;
      this.$refs.detailModal.showDetail(id);
    },
    closeMessage() {
      this.messageVisible = false;
    },
    closeDetail() {
      this.detailVisible = false;
      this.$refs.detailModal.closeDetail();
    },
    afterSave() {
      this.detailVisible = false;
      this.queryLogisticsListByObj(this.paramsObj);
    },
    async preReport() {
      let records = this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条物流信息',
          status: "error",
        });
        return
      }
      let idList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = await $api.reportData.request('preReport', {
        ids: idList
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('上报成功');
        this.records = [];
        this.refresh();
      } else {
        let data = res.data;
        let message = '';
        if (data.length > 0) {
          data.map(i => {
            message = message + i.failMsg + '\n';
          })
        }
        if (message === '') {
          this.$XModal.alert({
            message: "接口异常",
            status: "error",
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    showCarDetail(row) {
      if (row.carShipId) {
        this.createCarTitle = '查看车辆信息'
        this.createCarVisible = true;
        this.$refs.modalCarCreate.init();
        this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
        this.$refs.modalCarCreate.setReadOnly();
      } else {
        this.$XModal.alert({
          message: '暂无车辆信息',
          status: "error",
        });
      }
    },
    showShipDetail(row) {
      if (row.carShipId) {
        this.createShipTitle = '查看船舶信息'
        this.createShipVisible = true;
        this.$nextTick(() => {
          this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
          this.$refs.modalShipCreate.setReadOnly();
        })
      } else {
        this.$XModal.alert({
          message: '暂无船舶信息',
          status: "error",
        });
      }
    },
    closeCarCreateModal(type) {
      this.createCarVisible = false;
      // if (type === 'afterSave') {
      //   this.queryLogisticsList();
      // }
    },
    closeCarCreate() {
      this.$refs.modalCarCreate.reset();
    },
    closeCar() {
      this.createCarVisible = false;
      this.$refs.modalCarCreate.clearV();
    },
    closeShipCreateModal() {
      this.createShipVisible = false;
      // this.queryLogisticsList();
    },
    closeShipCreate() {
      this.$refs.modalShipCreate.reset();
    },
    reset() {
      this.searchFormData = {
        ordersNum: null,
        logisticsNum: null,
        logisticsCode: null,
        logisticsState: null,
        hasFile: null,
        busType: null,
        goodsName: null,
        carShipNum: null,
        hasTrackUrl: null,
        beginPlace: null,
        endPlace: null,
        beginTime: null,
        endTime: null,
        createTime: null,
        logisticsFileState: null,
        carShipState: null
      }
      this.searchBuyerName = [];
      this.searchSellerName = [];
      this.searchCompName = [];
      this.searchCreateUserName = [];
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
        name: ''
      };

      if (!isEmpty(query)) {
        params.name = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i)
          }
        })
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    refresh() {
      this.queryLogisticsListByObj(this.paramsObj);
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.seeCarMap(row)
      } else {
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      let url = '/carShip/fwCarFrame';
      this.fwCar = window.open(url);
      setTimeout(function () {
        that.fwCar.postMessage(JSON.stringify({carInfo: row, logistics: true}), '*');
      }, 2000);
    },
    seeShipMap(row) {
      let mmsi = row.mmsi;
      let carShipNum = row.carShipNum;
      if ((mmsi == null || mmsi === '') && (carShipNum === null || carShipNum === '')) {
        //暂无数据
        this.$Message.error('暂无数据');
        return
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi,
        carShipNum: carShipNum,
      }
      let that = this;
      let url = '/carShip/fwShipFrame';
      this.fwShip = window.open(url);
      this.$nextTick(function () {
        setTimeout(function () {
          that.fwShip.postMessage(JSON.stringify(obj), '*')
        }, 2000);
      });
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - (86400 * dayCount)) * 1000);//日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
    async queryLogisticsList() {
      this.loading = true;
      let res = await $api.logisticsTwo.post('logistics/list', {
        orderBy: 6,
        page: this.page.currentPage,
        rows: this.page.pageSize,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.rows;
        this.tableData.map((i) => {
          this.records.map((j) => {
            if (i.id === j.id) {
              this.$refs.xGrid.setCheckboxRow(i, true);
            }
          });
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryLogisticsListByObj(obj, isUpdateTrack) {
      obj.isUpdateTrack = isUpdateTrack == 1 ? 1 : 0
      this.loading = isUpdateTrack == 1 ? false : true;
      let res = await $api.logisticsTwo.post('logistics/list', obj);
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.rows;
        this.tableData.map((i) => {
          this.records.map((j) => {
            if (i.id === j.id) {
              this.$refs.xGrid.setCheckboxRow(i, true);
            }
          });
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    reTrack() {
      this.$XModal.confirm('请确认物流信息核对无误，确认后将付费获取最新轨迹').then(type => {
        if (type === 'confirm') {
          this.$Message.success('轨迹更新中，请稍后再来查看');
          this.queryLogisticsListByObj(this.paramsObj, 1);
        }
      })
    },
    async download() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("暂无数据")
        return
      }
      showLoading()
      let res = postBlob("/api/order/twoLogistics/logistics/exportLogisticsList", this.paramsObj);
      hideLoading()
      await saveBlob("导出物流.xls", res.data)
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime" && key !== "beginTime" && key !== "endTime" && obj[key] !== undefined) {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["beginTime"] && obj["beginTime"].length > 0) {
          paramsObj.beginTimeBegin = moment(obj.beginTime[0]).valueOf(); // 开始时间
          paramsObj.beginTimeEnd = moment(obj.beginTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["endTime"] && obj["endTime"].length > 0) {
          paramsObj.endTimeBegin = moment(obj.endTime[0]).valueOf(); // 开始时间
          paramsObj.endTimeEnd = moment(obj.endTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      paramsObj.orderBy = 6;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      if (this.searchBuyerName.length > 0) {
        paramsObj.buyerNameList = this.searchBuyerName;
      }
      if (this.searchSellerName.length > 0) {
        paramsObj.sellerNameList = this.searchSellerName;
      }
      if (this.searchCompName.length > 0) {
        paramsObj.platformCompanyIdList = this.searchCompName;
      }
      if (this.searchCreateUserName.length > 0) {
        paramsObj.createUserIdList = this.searchCreateUserName;
      }
      if (this.searchClientName.length > 0) {
        paramsObj.clientManagerIdList = this.searchClientName;
      }

      paramsObj.salesManId = this.salesManId ? this.salesManId : null;

      this.paramsObj = paramsObj;
      this.queryLogisticsListByObj(paramsObj);
      this.searchVisible = false;
    },
    showChainDetail(row) {
      if (!this.isHavePermission('chain:detail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.$router.push(`/order/detail/${row.chainId}`)
    },
    async setTop(id, logisticsState) {
      let res = await $api.logisticsTwo.post('logistics/updateLogisticsState', {
        id: id,
        logisticsState: logisticsState
      });
      if (res.status === 1) {
        this.$Message.success('操作成功');
        this.queryLogisticsListByObj(this.paramsObj);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    changePage(e) {
      if (this.paramsObj) {
        this.paramsObj.page = e.currentPage;
        this.paramsObj.rows = e.pageSize;
        this.paramsObj.goodsType = this.fliterName
        this.queryLogisticsListByObj(this.paramsObj);
      } else {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.queryLogisticsList();
      }
    },
    sortChangeEvent(sort) {
      console.log(sort)
      if (sort.order == null) {
        this.paramsObj.orderBy = 6
        this.paramsObj.isDesc = null
      } else {
        this.paramsObj.isDesc = sort.order === 'desc' ? 1 : 0
        if (sort.field === 'createTime') {
          this.paramsObj.orderBy = 2;
        }
        if (sort.field === 'addTime') {
          this.paramsObj.orderBy = 3;
        }
        if (sort.field === 'beginTime') {
          this.paramsObj.orderBy = 4;
        }
        if (sort.field === 'endTime') {
          this.paramsObj.orderBy = 5;
        }
      }
      this.queryLogisticsListByObj(this.paramsObj);
    },
    footerMethod({columns, data}) {
      const sums1 = [];
      const sums2 = [];
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums1.push('单页合计')
          sums2.push('全部合计')
        } else {
          let sum1Cell = null
          let sum2Cell = null
          switch (column.property) {
            case 'counts':
              sum1Cell = this.$utils.sum(data, column.property)
              sum2Cell = Math.round(this.totalCounts * 100) / 100
              break
            case 'realCount':
              sum1Cell = this.$utils.sum(data, column.property)
              sum2Cell = Math.round(this.totalRealCounts * 100) / 100
              break
          }
          sums1.push(sum1Cell)
          sums2.push(sum2Cell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums1, sums2]
    },
  }
}
</script>

<style>
@import "../../../src/assets/icon/icon-more/iconfont.css";

.button-gengduo {
  border: none;
}

.button-gengduo:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}
</style>
